import { AbstractModel } from ".";

export default class PublicationReaction extends AbstractModel {
  value!: string;
  total!: number;
}
